import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { router } from "./app/router/router";
import { OfflineBanner } from "@/components/carmel/OfflineBanner";
import { InstallBanner } from "@/components/carmel/InstallBanner";
import { UpdateNotification } from "@/components/carmel/UpdateNotification";
import { AccessibilityProvider } from "./providers/AccessibilityProvider";
import { SkipLink } from "@/components/carmel/SkipLink";
import { PageErrorBoundary } from "@/components/carmel/ErrorBoundary";
import { SplashScreen } from "@/components/carmel/SplashScreen";
import { useAuth } from "./app/providers/AuthProvider";

function App() {
  const { loading } = useAuth();

  if (loading) return <SplashScreen />;

  return (
    <AccessibilityProvider>
      <SkipLink />
      <OfflineBanner />
      <PageErrorBoundary>
        <RouterProvider router={router} />
      </PageErrorBoundary>
      <InstallBanner />
      <UpdateNotification />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "var(--card)",
            color: "var(--foreground)",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-lg)",
            fontSize: "14px",
            fontFamily: "var(--font-sans)",
          },
        }}
        richColors
        closeButton
      />
    </AccessibilityProvider>
  );
}

export default App;
